export default [
    {
        path: '/user/journey',
        props: true,
        component: () => import('@/views/User/Journey'),
    },
    {
        path: '/user/journey/map',
        props: true,
        component: () => import('@/views/User/Journey/Map'),
    },
];
